<template lang="pug">
v-layout.pa-4(align-center justify-center)
  v-flex( class='text-xs-center')
    v-form(:disabled="isLoading")
      small.font-size-11 ¿Cuenta con un contrato vigente?
      v-slide-group(
        v-model='tipoUsuario'
        mandatory
        show-arrows=''
      )
        v-slide-item.animated.fadeInLeft.faster(
          v-for='(n, index) in tiposUsuario'
          :value="n.value"
          :key='index'
          v-slot='{ active, toggle }'
        )
          v-card.elevation-1.ma-1.d-flex.ai-center.jc-center.text-center.flex-1(
            :color="active ? 'primary' : 'secondary primary--text'"
            height='60',
            :dark="active"
            width='140'
            @click='toggle'
          )
            span.font-size-13.font-weight-700 {{n.name}}
      .d-flex.items-end.jc-end(v-if="tipoUsuario === 'usuario-contrato'")
        v-text-field(
          v-model='ruc'
          light
          prepend-icon='circle'
          label='RUC (Requerido)'
          ref="ruc"
          type='number',
          @keyup.enter="fetchGetDatosSunat()"
          hide-details
        )
        v-tooltip(top='' )
          template(v-slot:activator='{ on, attrs }')
            v-btn.ml-4(fab, :disabled="isLoading" small v-bind='attrs' v-on='on'  @click="fetchGetDatosSunat()")
              img(src="../assets/sunat.svg", width="25" height="25")
          small Obtener datos de SUNAT
      v-text-field(
        v-model='nombre'
        light
        prepend-icon='person'
        label='Nombre personal o Razón social'
        @keyup="uppercase"
        ref="nombre"
        type='text',
        @keyup.enter="fetchRegistrarme()",
        :hint="direccion",
        :persistent-hint="direccion !== ''"
        :hide-details="!direccion"
      )
      v-text-field(
        v-model='username'
        light
        prepend-icon='email'
        @keyup="lowercase"
        label='Email (Requerido)'
        ref="username"
        type='email',
        @keyup.enter="fetchRegistrarme()"
        hide-details
      )
      v-text-field(
        v-model='password'
        prepend-icon='lock'
        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
        ref="password"
        :type="showPassword ? 'text' : 'password'"
        label='Ingrese una contraseña',
        @click:append='showPassword = !showPassword'
        hint="La contraseña ingresada será encriptada para mayor seguridad",
        persistent-hint,
        @keyup.enter="fetchRegistrarme()"
      )
        template(v-slot:progress='')
          v-progress-linear( :value='progress' :color='color' absolute='' height='2')

      v-checkbox.mt-0.pt-2(v-model='aceptaPoliticasDePrivacidad' color='info')
        template(v-slot:label='')
          strong(@click.stop="")
            | Acepto compartir datos - &nbsp;
            a(href='#'  @click.prevent="redirectProteccion()" ) LEY Nº 29733
      v-btn( block color="primary", @click="fetchRegistrarme()", :loading="isLoading")
        small  Registrarme
</template>

<script>
import Router from '../router/not_logged.js'
import { apiGet, apiPost, notify } from '../util/general'
export default {
  name: 'Register_user',
  data () {
    return {
      nombre                     : '',
      username                   : '',
      password                   : '',
      ruc                   : '',
      direccion                  : '',
      isLoading                  : false,
      showPassword               : false,
      showPassword1              : false,
      aceptaPoliticasDePrivacidad: true,
      tipoUsuario : 'usuario',
      tiposUsuario         : [
        {
          name : 'No tengo contrato',
          value: 'usuario'
        },
        {
          name : 'Tengo un contrato',
          value: 'usuario-contrato'
        }
      ]
    }
  },
  computed: {
    progress () {
      var vm = this
      return Math.min(100, vm.password.length * 16.7)
    },
    color () {
      var vm = this
      return ['error', 'warning', 'success'][Math.floor(vm.progress / 40)]
    }
  },
  methods: {
    uppercase (e) {
      var vm = this
      vm.nombre = e.target.value.toUpperCase();
    },
    lowercase (e) {
      var vm = this
      vm.username = e.target.value.toLowerCase();
    },
    validateEmail (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },
    fetchLogin () {
      var vm          = this
      var obj = {
        empresa : process.env.EMPRESA,
        username: vm.username,
        password: vm.password
      }

      vm.axios.post('/usuario/login', obj).then((response) => {
        var data = response.data
        if (data.status) {
          localStorage.setItem('perfil', data.perfil)
          localStorage.setItem('username', data.username)
          localStorage.setItem('codigoCliente', data.codigoCliente)
          localStorage.setItem('nombre', data.nombre)
          localStorage.setItem('razonSocial', data.razonSocial)
          localStorage.setItem('entidad', data.entidad)
          localStorage.setItem('token', data.token)
          // vm.goTo('/ticket')
          window.location.reload(true)
          // vm.$store.dispatch('transaccion', {isProceso : false})
        } else {
          notify(vm, 'error', 'Error', data.message)
          vm.isLoading = false
        }
      }).catch((error) => {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    fetchGetDatosSunat () {
      var vm = this

      if (!vm.ruc) {
        notify(vm, 'error', 'Error', 'Ingrese un numero de RUC')
        vm.$refs.ruc.focus()
        return;
      }
      vm.nombre = ''
      vm.direccion = ''
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo información de SUNAT' })
      var obj = {
        ruc: vm.ruc
      }
      apiGet(vm, '/cliente/sunat', obj, function (data) {
        console.log('data', data)
        if (data.empresa) {
          vm.nombre = data.empresa.nombre_o_razon_social
          vm.direccion = data.empresa.direccion
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, () => {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchRegistrarme () {
      var vm          = this
      var url = '/usuario/registrar'
      if (vm.tipoUsuario === 'usuario-contrato' && !vm.ruc) {
        notify(vm, 'error', 'Error', 'El RUC de la empresa es  requerido.')
        vm.$refs.ruc.focus()
        return
      }

      if (!vm.nombre) {
        notify(vm, 'error', 'Error', 'Ingrese un nombre u razon social valido')
        vm.$refs.nombre.focus()
        return
      }

      if (!vm.username) {
        notify(vm, 'error', 'Error', 'Ingrese un email valido')
        vm.$refs.username.focus()
        return
      }

      if (vm.username) {
        if (!vm.validateEmail(vm.username)) {
          notify(vm, 'error', 'Error', 'El email no cumple con el formato adecuado')
          vm.$refs.username.focus()
          return
        }
      }

      if (!vm.password) {
        notify(vm, 'error', 'Error', 'Ingrese un password valido')
        vm.$refs.password.focus()
        return
      }

      if (vm.password && vm.progress < 100) {
        notify(vm, 'error', 'Error', 'La contraseña debe de tener como minimo 6 caracteres')
        vm.$refs.password.focus()
        return
      }

      vm.isLoading = true
      var obj = {
        nombre                     : vm.nombre,
        username                   : vm.username,
        password                   : vm.password,
        aceptaPoliticasDePrivacidad: vm.aceptaPoliticasDePrivacidad ? 1 : 0,
        ruc: vm.ruc,
        tipoUsuario : vm.tipoUsuario
      }

      apiPost(vm, url, obj, data => {
        vm.fetchLogin()
      }, error => {
        notify(vm, 'error', 'Error', error.message)
        vm.isLoading = false
      })
    },
    goTo (page) {
      Router.push(page)
    },
    redirectProteccion () {
      // var vm = this
      window.open('https://www.minjus.gob.pe/wp-content/uploads/2013/04/LEY-29733.pdf', '_blanck')
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// Register_user.vue?3d260bb7